import request from '@/utils/request'

export function getEvlHeader(param) {
    let data = param    
    return request({
      url: `/v10/getEvlHeader`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function getEvlDetails(param) {
    let data = param
    return request({
      url: `/v10/getEvlDetails`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function getEvlHeaderEff(param) {
    let data = param    
    return request({
      url: `/v10/getEvlHeaderEff`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function getEvlDetailEff(param) {
    let data = param
    return request({
      url: `/v10/getEvlDetailEff`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function getEvlRef(param) {
    let data = param    
    return request({
      url: `/v10/getEvlRef`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }


  export function chkEvlGap(param) {
    let data = param
    return request({
      url: `/v10/chkEvlGap`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }
   
  export function updateEvl(param) {
    let data = param
    return request({
      url: `/v10/updateEvl`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  